import { render, staticRenderFns } from "./admin-search-organizations.vue?vue&type=template&id=07d1089d&scoped=true&"
import script from "./admin-search-organizations.vue?vue&type=script&lang=js&"
export * from "./admin-search-organizations.vue?vue&type=script&lang=js&"
import style0 from "./admin-search-organizations.vue?vue&type=style&index=0&id=07d1089d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1089d",
  null
  
)

export default component.exports